export type BusinessProfileId = 'retail' | 'restaurant' | 'bar-nightclub' | 'services' | 'custom';

export type BusinessProfile = {
  id: BusinessProfileId;
  label: string;
  description: string;
  productLabel: string;
  productsLabel: string;
  categoryLabel: string;
  posLabel: string;
  inventoryLabel: string;
  defaultUnits: string[];
  capabilities: string[];
  aiVocabulary: string[];
};

export const businessProfiles: Record<BusinessProfileId, BusinessProfile> = {
  retail: {
    id: 'retail', label: 'Tienda y comercio', description: 'Productos, variantes, mayoreo, código de barras y existencias.',
    productLabel: 'Producto', productsLabel: 'Productos', categoryLabel: 'Categoría', posLabel: 'Punto de venta', inventoryLabel: 'Inventario',
    defaultUnits: ['pieza', 'caja', 'paquete', 'kg', 'g', 'litro', 'ml'],
    capabilities: ['barcode', 'variants', 'wholesale', 'catalog', 'special-orders'],
    aiVocabulary: ['producto', 'pieza', 'apartado', 'mayoreo', 'talla', 'color', 'reposición'],
  },
  restaurant: {
    id: 'restaurant', label: 'Restaurante y cafetería', description: 'Platillos, modificadores, ingredientes, mesas y pedidos.',
    productLabel: 'Platillo', productsLabel: 'Menú', categoryLabel: 'Sección', posLabel: 'Comandas', inventoryLabel: 'Insumos',
    defaultUnits: ['porción', 'pieza', 'kg', 'g', 'litro', 'ml'],
    capabilities: ['modifiers', 'recipes', 'tables', 'kitchen', 'delivery'],
    aiVocabulary: ['platillo', 'comanda', 'mesa', 'extra', 'sin', 'término', 'ingrediente'],
  },
  'bar-nightclub': {
    id: 'bar-nightclub', label: 'Bar, antro o club', description: 'Cuentas abiertas, botellas, copas, barras, cortesías y reservaciones.',
    productLabel: 'Producto de barra', productsLabel: 'Carta', categoryLabel: 'Familia', posLabel: 'Servicio y cuentas', inventoryLabel: 'Barras e inventario',
    defaultUnits: ['botella', 'copa', 'shot', 'ml', 'pieza', 'servicio'],
    capabilities: ['open-tabs', 'tables', 'bottle-portions', 'courtesies', 'reservations', 'commissions'],
    aiVocabulary: ['cuenta', 'mesa', 'botella', 'copa', 'shot', 'barra', 'cortesía', 'VIP'],
  },
  services: {
    id: 'services', label: 'Servicios y trabajos', description: 'Servicios, citas, anticipos, materiales y trabajos en proceso.',
    productLabel: 'Servicio', productsLabel: 'Servicios', categoryLabel: 'Tipo de servicio', posLabel: 'Cobros', inventoryLabel: 'Materiales',
    defaultUnits: ['servicio', 'hora', 'sesión', 'pieza', 'metro', 'm²'],
    capabilities: ['appointments', 'commissions', 'deposits', 'work-orders', 'materials'],
    aiVocabulary: ['servicio', 'cita', 'anticipo', 'trabajo', 'responsable', 'fecha prometida'],
  },
  custom: {
    id: 'custom', label: 'Negocio personalizado', description: 'Activa únicamente las herramientas que necesita tu operación.',
    productLabel: 'Producto o servicio', productsLabel: 'Productos y servicios', categoryLabel: 'Categoría', posLabel: 'Ventas', inventoryLabel: 'Inventario',
    defaultUnits: ['pieza', 'servicio', 'kg', 'g', 'litro', 'ml'],
    capabilities: ['catalog', 'special-orders'],
    aiVocabulary: ['producto', 'servicio', 'venta', 'pedido', 'inventario'],
  },
};

export const getBusinessProfile = (profileId?: string) => businessProfiles[(profileId as BusinessProfileId) ?? 'custom'] ?? businessProfiles.custom;
